module.exports = __webpack_public_path__ + "img/logo.c18e06fa.png";